export const languages = {
         english: {
           dir: "ltr",
           lang: "en",
           title: "Article on creating a multilingual site with RACT and Redex",
           content:
             "In this article, you will learn how to operate a multi-lingual website in REACT without any library",
           youLang: "Site language now",
           link: "link",
           article: "article",
         },
         arbic: {
           dir: "rtl",
           lang: "ar",
           title: "مقال حول إنشاء موقع متعدد اللغات بواسطة رياكت وريدكس",
           content:
             "في هذه المقالة ، ستتعلم كيفية تشغيل موقع ويب متعدد اللغات في REACT بدون أي مكتبة",
           youLang: "لغة الموقع الان",
           link: "رابط",
           article: "المقال",
         },
         france: {
           dir: "ltr",
           lang: "fr",
           title:
             "Article sur la création d'un site multilingue avec RACT et Redex",
           content:
             "Dans cet article, vous apprendrez à faire fonctionner un site Web multilingue dans REACT sans aucune bibliothèque",
           youLang: "Langue du site maintenant",
           link: "lien",
           article: "l'article",
         },
       };
